var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "55px",
    viewBox: "0 0 54 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MAP/blueTriangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blueTriangle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mapTriangleUnlocked",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99372699,51.7668243 C19.2957284,36.4328601 36.3963671,19.1384777 51.8178234,6.17254336 C52.1073376,21.2347664 51.5283092,36.9569323 51.0843874,51.9997453 C35.7401349,52.2908965 20.3186786,52.0773856 4.99372699,51.7668243 Z",
    id: "SHADOW",
    strokeWidth: 1.81395349,
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Triangles_1_",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9412963,3.74274632 C47.1558034,17.2811014 46.8876695,33.7026247 46.7625404,47.1693483 C46.0117657,46.4172175 43.2231738,43.3907862 42.8120353,42.4237609 C43.2231738,28.5272482 43.7773171,14.0218678 43.4913077,0.143263017 C44.5102162,1.30727503 45.6363783,2.5787343 46.9412963,3.74274632 Z",
    id: "side",
    strokeWidth: 1.81395349,
    fill: "#17A9B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.795193, 2.686182)",
    strokeWidth: 1.20930233
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.589894432,9.65234576 C1.26916681,10.1895821 1.85906124,10.6730948 2.53833362,11.2282389",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.339636188,13.2339212 C1.05465974,13.9144205 2.0914439,15.1679719 2.93159657,15.7052082",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.572018843,17.4064566 C1.26916681,17.925785 2.07356831,18.6241922 2.46683126,19.4121388",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.446889721,21.865518 C1.19766445,22.5460173 2.46683126,23.2086087 3.05672569,23.8174766",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.46476531,25.5724485 C1.14403769,26.1455006 2.28807537,26.9155393 3.00309893,27.4348677",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0893779442,28.7958664 C0.76865032,29.6554445 2.30595096,30.4433911 3.07460128,31.2134298",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0893779442,32.1267315 C0.822277087,33.3265593 2.0914439,34.4547556 3.05672569,35.4755046",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.286009422,36.9797662 C0.911655031,37.8751601 2.21657302,39.0212642 2.98522334,39.7913029",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.589894432,0.0895393855 C1.41217152,0.913301733 1.96631477,1.79078771 2.94947216,2.48919492",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.62564561,6.03495459 C1.51942505,6.48265151 2.35957773,7.64666353 3.14610364,8.27343922",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0536267665,42.2088663 C14.2647199,42.4774845 28.5294398,42.692379 42.8120353,42.4237609 C43.2231738,43.4624177 46.0117657,46.4172175 46.7625404,47.1693483 C40.9350985,47.0977168 16.4634173,46.8111908 2.59196038,46.9544538 C1.85906124,46.4351253 0.643521199,43.7489438 0.0536267665,42.2088663 Z",
    id: "bottom",
    strokeWidth: 1.81395349,
    fill: "#17A9B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.340669, 43.122168)",
    strokeWidth: 1.20930233
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.751807707,0.358157542 C1.41320449,1.45053805 2.1997304,2.59664218 2.8432516,3.65320693",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11241841,0.984933241 C4.52355695,2.05940587 4.91681991,2.61455006 5.39946081,3.65320693",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52665588,0.626775699 C7.99142119,1.70124833 8.38468415,2.5787343 8.84944946,3.65320693",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6727595,0.55514419 C11.2269028,1.61170894 11.6022901,2.5071028 12.0134287,3.61739118",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7116096,0.68049933 C13.9261167,1.79078771 14.1048726,2.45337916 14.7662694,3.3666809",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0543447,0.608867822 C17.7336171,1.46844592 17.9659998,2.68618157 18.5737698,3.34877302",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2540751,1.05656475 C20.9512231,1.86241922 21.129979,3.11597062 21.6304955,3.77856207",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3108008,0.698407207 C24.0079488,1.64752469 24.3833362,2.81153671 24.9911062,3.79646995",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1183013,1.00284112 C27.9763295,1.96986648 28.2087122,2.84735246 28.9594869,3.77856207",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6040411,0.573052068 C31.2296867,1.52216955 31.694452,2.52501067 32.3200976,3.27714151",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0540297,0.68049933 C34.4472927,1.54007743 35.1086895,2.25639252 35.6449571,3.02643123",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2369175,0.93120961 C38.9340655,2.1131295 39.5597111,2.88316821 40.4534905,3.93973296",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.0536267665,42.2088663 C13.2994381,28.0616434 29.1372098,12.1057249 43.4198053,0.143263017 C43.6879391,14.0397757 43.1516715,28.5451561 42.7405329,42.4237609 C28.5294398,42.692379 14.2468443,42.4953924 0.0536267665,42.2088663 Z",
    id: "outline",
    strokeWidth: 1.81395349,
    fill: "#1BC6D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTriangle);
export default __webpack_public_path__ + "static/media/blueTriangle.9a0297a283724e16f2e10a68d8d9b23f.svg";
export { ForwardRef as ReactComponent };